<template>
  <div class="reimbursement-type">
    <div class="reimbursement-type-container">
      <div class="left-container">
        <type-tree 
          :list="list"
          :listId="id"
          :type="type"
          @selectTreeNodeList="selectTreeNodeList"
          @openReimbursemnetAddBill="openReimbursemnetAddBill"
          @reimbursemnetDel="reimbursemnetDel"
        />
      </div>
        <div class="container" v-if="id">
          <div class="phone">
            <div class="inset-phone">
              <div class="title">
                <div class="title-name">
                  <p v-if="isMod">{{ title }}</p>
                  <el-input ref="customerInput" v-else class="gray white" v-model="title" autofocus @blur="blur"></el-input>
                </div>
                <img src="../../../../assets/mod.png" @click="mod">
              </div>
              <div v-if="reimbursementTypeId == 2">
                <div class="row">
                  <div class="sub-title">
                    单位
                  </div>
                  <div class="phone-content">系统自动获取</div>
                </div>
                <div class="row">
                  <div class="sub-title">
                    <span>日期</span>
                    <span class="star">*</span>
                  </div>
                  <div class="phone-content">
                    <span>请选择</span>
                    <i class="el-icon-arrow-right"></i>
                  </div>
                </div>
                <div class="row">
                  <div class="sub-title">
                    <span>单据张数</span>
                    <span class="star">*</span>
                  </div>
                  <div class="phone-content">
                    <span>请输入</span>
                  </div>
                </div>
                <div class="row">
                  <div class="sub-title">
                    <span>费用明细</span>
                    <span class="star">*</span>
                  </div>
                  <div class="cost-details">
                    <span>+费用明细</span>
                  </div>
                </div>
                <div class="row" v-if="isForProperty == 1">
                  <div class="sub-title">
                    <span>资产明细</span>
                    <span class="star">*</span>
                  </div>
                  <div class="cost-details">
                    <span>+资产明细</span>
                  </div>
                </div>
                <div class="row">
                  <div class="sub-title">
                    <span>验收人</span>
                    <span class="star">*</span>
                  </div>
                  <div class="phone-content">
                    <span>请选择</span>
                    <i class="el-icon-arrow-right"></i>
                  </div>
                </div>
                <div class="total">
                  <div class="row">
                    <div class="sub-title">
                      合计（元）
                    </div>
                    <div class="phone-content">系统自动计算</div>
                  </div>
                  <div class="capitalize">大写：待计算</div>
                </div>
              </div>
              <div v-else class="phone-main">
                <div class="row">
                  <div class="sub-title">
                    报销人
                  </div>
                  <div class="phone-content">系统自动获取</div>
                </div>
                <div class="row">
                  <div class="sub-title">
                    部职级
                  </div>
                  <div class="phone-content">系统自动获取</div>
                </div>
                <div class="row">
                  <div class="sub-title">
                    <span>出差事由</span>
                    <span class="star">*</span>
                  </div>
                  <div class="phone-content">
                    <span>请输入</span>
                  </div>
                </div>
                <div class="row">
                  <div class="sub-title">
                    <span>出行方式</span>
                    <span class="star">*</span>
                  </div>
                  <div class="phone-content">
                    <span>请输入</span>
                  </div>
                </div>
                <div class="row">
                  <div class="sub-title">
                    同行人数
                  </div>
                  <div class="phone-content">系统自动获取</div>
                </div>
                <div class="row">
                  <div class="sub-title">
                    到达地点
                  </div>
                  <div class="phone-content">系统自动获取</div>
                </div>
                <div class="date">
                  <div class="row">
                    <div class="sub-title">
                      <span>出差日期（开始）</span>
                    </div>
                    <div class="phone-content">
                      <span>系统自动获取</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="sub-title">
                      <span>出差日期（结束）</span>
                    </div>
                    <div class="phone-content">
                      <span>系统自动获取</span>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="sub-title">
                    <span>出差天数</span>
                  </div>
                  <div class="phone-content">
                    <span>系统自动获取</span>
                  </div>
                </div>
                <div class="row">
                  <div class="sub-title">
                    <span>备注</span>
                  </div>
                  <div class="phone-content">
                    <span>请输入</span>
                  </div>
                </div>
                <div class="row no-bottom border-btm">
                  <div class="sub-title">
                    <span>费用明细</span>
                    <span class="star">*</span>
                  </div>
                  <div class="cost-details">
                    <span>
                      <i class="el-icon-download"></i>
                      费用明细</span>
                  </div>
                </div>
                <div class="row no-top">
                  <div class="sub-title">
                    <span>申报金额</span>
                  </div>
                  <div class="phone-content">
                    <span>自动计算数额</span>
                  </div>
                </div>
                <div class="row">
                  <div class="sub-title switch-container">
                    <span>未使用公务卡结算审批单</span>
                    <el-switch
                      v-model="isSwitch"
                      disabled>
                    </el-switch>
                  </div>
                  <div class="cost-details">
                    <span>
                      <i class="el-icon-download"></i>
                      从预审批单导入</span>
                  </div>
                </div>
                <div class="row">
                  <div class="sub-title switch-container">
                    <span>是否上会</span>
                    <el-switch
                      v-model="isSwitch"
                      disabled>
                    </el-switch>
                  </div>
                  <div class="cost-details">
                    <span>
                      <i class="el-icon-download"></i>
                      从资料导入</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="right-container"  v-if="id">
          <el-form
            :model="ruleForm"
            ref="ruleForm"
            class="demo-ruleForm"
          >
            <el-form-item v-if="reimbursementTypeId == 2" label="实物采购验收" prop="purchaseAcceptance">
              <el-radio-group v-model="ruleForm.purchaseAcceptance">
                <el-radio :label="1">开启</el-radio>
                <el-radio :label="0">关闭</el-radio>
              </el-radio-group>
            </el-form-item>
            <!-- <el-form-item label="关联预审批单" prop="relation">
              <SelectPreliminary
                :departmentList="preliminaryList"
                :departmentId="departmentId"
                @selectTreeNodeList="selectDepartmentList"
              >
              </SelectPreliminary>
            </el-form-item> -->
            <el-form-item label="补齐资料提示语" prop="supplementDataNotice">
              <el-input
                type="textarea"
                placeholder="请输入内容"
                v-model="ruleForm.supplementDataNotice"
                maxlength="100"
                show-word-limit
                resize="none"
                rows="6"
              />
            </el-form-item>
          </el-form>
        </div>
        <div class="foot-container"  v-if="id">
          <el-button
          v-if="
                OPERATION_LIST.findIndex(
                  (item) => item === OPERATIONS_BTNS.roleUpdateReimburseForm
                ) !== -1
              "
          class="btn-blue" type="primary" @click="save('ruleForm')">保存</el-button>
          <el-button
          v-if="
                OPERATION_LIST.findIndex(
                  (item) => item === OPERATIONS_BTNS.roleUpdateReimburseForm
                ) !== -1 && isForProperty !=1
              "
          class="btn-blue" type="primary" @click="toModPrint">打印模板</el-button>
        </div>
        <div v-if="!id" class="nothing">
          <div>
            <div>
              <img src="../../../../assets/nothing.png">
            </div>
            <p>暂无数据</p>
          </div>
        </div>
    </div>

    <!-- 新增单据 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="540px"
      :before-close="handleClose"
    >
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        class="demo-ruleForm"
      >
        <el-form-item label="单据名称" prop="billName">
          <el-input class="gray white" v-model="form.billName"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirm('form')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { config } from '@/common/js/config.js'
import TypeTree from '@/components/type-tree.vue'
import BillAdmin from "@/models/bill-admin.js";
import { mapId, mapId4 } from "@/common/js/utils.js";
import { operationMixins } from '@/common/mixins/operation/operation.js'
import SelectPreliminary from "@/components/select-preliminary";
export default {
  mixins: [operationMixins],
  components: {
    TypeTree,
    SelectPreliminary
  },

  data() {
    return {
      list: [],
      id: 0,
      type: 1,
      title: '',
      isMod: true,
      ruleForm: {
        purchaseAcceptance: 0,
        relation: [],
        supplementDataNotice: ''
      },
      selectPreliminaryIdList: [],
      selectPreliminary: [],
      isSearch: false,
      preliminaryList: [],
      // 存预审批类型数据
      storePreliminaryList: [],
      departmentId: [],
      reimbursementTypeId: '',
      isSwitch: true,
      // 是否是资产购置
      isForProperty: '',

      
      /* -----------------   以下是重命名, 新增单据字段   ----------- */
      dialogVisible: false,
      form: {
        billName: '',
        typeId: ''
      },
      rules: {
        billName: [{ required: true, message: "请输入单据名称", trigger: "blur" }],
      },
      dialogTitle: '',
    }
  },

  created() {
    config()
    this.initDepartmentList()
    // this.initCashierList()
    this.initPreliminaryTypeList()
  },

  methods: {
    /* 获取单据类型数据 */
    initDepartmentList() {
      let queryStr = ''
      BillAdmin.getReimbursementTypeList(queryStr).then(res => {
        if (res.success) {
          let arr = this.mapChild(res.result);
          this.list = mapId4(arr, this.id)
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },

    /* 获取关联预审批单 */
    initPreliminaryTypeList() {
      let queryStr = ''
      BillAdmin.getPreliminaryTypeList(queryStr).then(res => {
        if (res.success) {
          let arr = this.mapChild2(res.result);
          this.preliminaryList = mapId(arr, this.departmentId)
          this.storePreliminaryList = this.preliminaryList
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },

    mapChild2(child) {
      let arr = [];
      child.map((value) => {
        let obj = {};
        obj.id = value.id;
        obj.label = value.name;
        obj.level = value.level;
        obj.officialType = value.systemPreset;
        obj.identification = value.identification
        if (value.subList && value.subList.length > 0 && value.level == 1) {
          obj.children = this.mapChild2(value.subList);
        } else {
          if (value.preApprovalFormList && value.preApprovalFormList.length > 0) {
            obj.children = this.mapChild2(value.preApprovalFormList);
          } else {
            obj.children = [];
          }
        }
        arr.push(obj);
      });
      return arr;
    },

    mapChild(child) {
      let arr = [];
      child.map((value) => {
        let obj = {};
        obj.id = value.id;
        obj.label = value.name;
        obj.level = value.level;
        obj.isForProperty = value.isForProperty;
        obj.reimbursementTypeId = value.reimbursementTypeId ? value.reimbursementTypeId : ''
        if (value.reimburseFormList && value.reimburseFormList.length > 0) {
          obj.children = this.mapChild(value.reimburseFormList);
        } else {
          obj.children = [];
        }
        arr.push(obj);
      });
      return arr;
    },

    /* 树结构筛选 */
    treeFilter(tree, func) {
      // 使用map复制一下节点，避免修改到原树
      return tree.map(node => ({ ...node })).filter(node => {
        node.children = node.children && this.treeFilter(node.children, func)
        return func(node) || (node.children && node.children.length)
      })
    },

    /* 获取报销单详情 */
    _getReimbursementDetails() {
      let id = this.id
      BillAdmin.getReimbursementDetails(id).then(res => {
        if (res.success) {
          this.ruleForm.purchaseAcceptance = res.result.physicalProcurementAcceptanceFlag
          this.ruleForm.supplementDataNotice = res.result.supplementDataNotice
          let arr = []
          res.result.preFormList.map(i => {
            let obj = {}
            obj.id = i.id
            obj.label = i.name
            arr.push(obj)
          })
          this.departmentId = arr
          this.$nextTick(() => {
            this.$bus.emit('getFepartmentId',  this.departmentId)
          })
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },

    selectTreeNodeList(v) {
      if (v.level == 2) {
        this.id = v.id
        this.title = v.label
        this.reimbursementTypeId = v.reimbursementTypeId
        this.isForProperty = v.isForProperty
        this.ruleForm.relation = []
        this.selectPreliminaryIdList = []
        this._getReimbursementDetails()
        this.$nextTick(() => {
          this.$bus.emit('init')
        })
        let arr = []
        if (v.reimbursementTypeId == 1) {
          arr = this.treeFilter(this.storePreliminaryList, node => node.officialType == 1)
        } else {
          arr = this.treeFilter(this.storePreliminaryList, node => node.officialType == 0)
        }
        this.preliminaryList = arr
      } else {
        this.id = 0
      }
    },

    mod() {
      this.isMod = false
      this.$nextTick(function () {
        this.$refs.customerInput.$el.querySelector('input').focus();
      });
    },

    blur() {
      this.isMod = true
      let data = {}
      data.name = this.title
      data.reimbursementId = this.id
      BillAdmin.postModReimbursementName(data).then(res => {
        if (res.success) {
          this.$message({
            type: 'success',
            message: '修改成功'
          });
          this.initDepartmentList()
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },

    selectDepartmentList(v) {
      this.departmentId = v
      this.selectPreliminaryIdList = v
    },

    save(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {}
          data.name = this.title
          data.reimbursementId = this.id
          data.physicalProcurementAcceptanceFlag = this.ruleForm.purchaseAcceptance
          data.supplementDataNotice = this.ruleForm.supplementDataNotice
          let arr = []
          this.departmentId.map(i => {
            arr.push(i.id)
          })
          data.preApprovalIdList = arr
          BillAdmin.postModReimbursement(data).then(res => {
            if (res.success) {
              this.$message({
                type: 'success',
                message: '修改成功'
              });
              this.initDepartmentList()
            } else {
              this.$message({
                type: 'error',
                message: res.message
              });
            }
          })
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    
    /* -----------------   以下是新增单据方法   ----------- */
    handleClose() {
      this.dialogVisible = false
    },

    confirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            name: this.form.billName,
            reimbursementTypeId: this.form.typeId
          }
          BillAdmin.postAddReimbursement(data).then(res => {
            if (res.success) {
              this.$message({
                type: 'success',
                message: '新增单据成功'
              });
              this.initDepartmentList()
              this.handleClose()
            } else {
              this.$message({
                type: 'error',
                message: res.message
              });
            }
          })
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    /* 添加单据 */
    openReimbursemnetAddBill(v) {
      this.dialogTitle = '添加单据'
      this.dialogVisible = true
      this.form.typeId = v.id
    },

    /* 删除单据 */
    reimbursemnetDel(v) {
      this.$confirm("分类删除后不可恢复，是否继续？", "确认删除分类", {
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        confirmButtonClass: 'btn-red',
        cancelButtonClass: 'btn-gray'
      }).then(() => {
        let data = {
          id: v.id
        }
        BillAdmin.getDelReimbursementTypeList(data).then(res => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: '删除成功'
            });
            this.initDepartmentList()
          } else {
            this.$message({
              type: 'error',
              message: res.message
            });
          }
        })
      });
    },

    /* 跳转打印模板 */
    toModPrint() {
      this.$router.push({
        path: '/formIndex/formControl',
        query: {
          officialType: this.reimbursementTypeId,
          typeId: this.id
        }
      })
    },
  }
}
</script>

<style lang='scss'>
.el-select-dropdown__item.hover, .el-select-dropdown__item:hover {
  background: $bg-white;
}
.foot-container {
  .el-button {
    padding: 0;
  }
}
.reimbursement-type {
  .container .phone .inset-phone .no-bottom {
    margin-bottom: 0px;
  }
  .container .phone .inset-phone .no-top {
    margin-top: 0px;
  }
  .border-btm {
    border-bottom: 1px solid $bg-ShallowLightSnow;
  }
  .container .phone .inset-phone .row .switch-container {
    width: 100%;
    @include flex-between;
  }
  .el-switch.is-disabled {
    opacity: 1;
  }
  .el-textarea {
    margin-top: 10px;
  }
}
.nothing {
  position: absolute;
  left: 60%;
  top: 50%;
  img {
    width: 157px;
    height: 157px;
  }
  p {
    font-size: $fs-small-l;
    font-weight: 400;
    color: $color-LightGrey;
    margin-top: 24px;
  }
}
</style>
